export default {
    reviewOrder: {
        reviewOrder: "Orden de revisión"
    }
}